/** Created by azhou on 2018/5/18.*/
<template>
  <div>
    <!--积分规则-->
    <div class="border rounded bg-base mb-4 text-left p-4">
      <span class="font-weight-bold h4"> 等级规则及说明：</span>
      <ul class="mt-3" v-if="userInfo.type===3">
        <li class="mb-2"><span class="mr-2 text-danger">(1)</span>参与订单报价(+10)</li>
        <li class="mb-2"><span class="mr-2 text-danger">(2)</span>订单成交并完成(+订单金额10%)</li>
        <li class="mb-2"><span class="mr-4 text-danger"></span>
        如:订单金额为
        <span class="mr-1 text-warning">10800</span>元,则取<span class="mr-1 text-warning">10%</span>后得<span class="mr-1 text-warning">1080</span>点活跃值
        </li>
        <li class="mb-2"><span class="mr-4 text-danger"></span>
        如:订单金额为
        <span class="mr-1 text-warning">128</span>元,则取<span class="mr-1 text-warning">10%</span>后得<span class="mr-1 text-warning">12</span>点活跃值
        </li>
      </ul>
      <!-- <ul class="mt-3" v-if="$GFUN.isInArray([5,6,8],userInfo.type)">
        <li class="mb-2"> 获得活跃值目前有2种途径：</li>
        <li class="mb-2" v-if="userInfo.type != 8">1、入驻平台后：活跃值+10000点</li>
        <li class="mb-2">{{userInfo.type == 8 ? 1 : 2}}、订单预订成功后：活跃值+订单总额10%</li>
        <li class="mt-3">如：订单总额是10800元，那么，取10%后得1080点活跃值</li>
        <li class="mb-2">如：订单金额为128元，那么，取10%后得12点活跃值</li>
      </ul> -->
    </div>
    <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
    <ul class="list-item" v-for="item in RankList" :key="item.grade">
      <li class="w-50 list-item-col">{{item.grade}}</li>
      <li class="w-50 list-item-col">{{item.min}} ~ {{item.max}}</li>
      <li class="w-50 list-item-col">
        <img :src="item.pic ? '/images/grade/'+ item.pic : ''" alt="酒店等级" height="26px">
      </li>
    </ul>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name:'RankRules',
    data() {
      return {
        RankList: [],
        titleArr:['等级','活跃值','等级图标']
      }
    },
    computed: {
      ...mapGetters(['userInfo','storeInfo','isGroup'])
    },
    async created() {
      let res = await this.$axios.post('/pc/Common/getExpRule',{store_id:this.isGroup ? this.storeInfo.grostoreId :this.storeInfo.storeId});
      if (res.code === '00000' || res.code === '99999') {
        this.RankList = res.info || [];
      }
    },
  }
</script>
